const ACCESS_TOKEN_KEY = 'mDo7fVhH1uXP50GLhf';
const REFRESH_TOKEN_KEY = 'NYks3AnZSdMTbc5pOy';
const IMPERSONATING_KEY = '45881f327ea4';
const USER_KEY = 'user';
var ROLE;
(function (ROLE) {
    ROLE[ROLE["ANONYMOUS"] = 0] = "ANONYMOUS";
    ROLE[ROLE["USER"] = 1] = "USER";
})(ROLE || (ROLE = {}));
export { ACCESS_TOKEN_KEY, IMPERSONATING_KEY, REFRESH_TOKEN_KEY, ROLE, USER_KEY };
//# sourceMappingURL=state.js.map